import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import Loader from "../../components/loder";
import ProfileCard from "../../components/play-back-card";
import { colors } from "../../constants/colors";
import BottomVehicleDetails from "../../components/bottom-vehicle-details";
import {
  getAddressFromLatLong,
  getDeviceDetails,
} from "../../redux/actions/service-action";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col } from "reactstrap";
import { useSelector } from "react-redux";
import VehicleList from "../../components/Vehicles/Vehicles";

const Profile = () => {
  const { remainingWatchTime } = useSelector((state: any) => state.service);
  const { userMobileNumber } = useSelector((s: any) => s?.service);
  const loading = false;
  const [boxWidth, setBoxWidth] = useState(window.innerWidth - 200);
  const [deviceDetails, setDeviceDetails] = useState({});
  const [getLocationData, setLastLocation] = useState("");
  const [getDriverDetails, setDriverDetails] = useState({});
  const [getImagedata, setImageData] = useState({});
  const userDetails = useSelector((state: any) => state?.auth?.loginDetails?.user_details[0]);

  useEffect(() => {
    const handleResize = () => setBoxWidth(window.innerWidth - 200);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleTabClick = async (details: any) => {
    try {
      const res = await getDeviceDetails(details?.deviceno);
      if (res) {
        setImageData(res?.imageData);
        setDeviceDetails(res.formattedDeviceDetails);
        const address = await getAddressFromLatLong(
          res.lastLocation?.latitude,
          res.lastLocation?.longitude
        );
        setLastLocation(address);
        setDriverDetails(details);
      }
    } catch (error) {
      console.error("error==>", error);
    }
  };
  const convertSecondsToHHMM = (minutes: any) => {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(remainingMinutes).padStart(2, "0");
    return `${formattedHours}:${formattedMinutes}`;
  };
  return (
    <>
      <Container
        fluid
        className="position-absolute d-flex flex-column"
        style={{
          right: 0,
          height: "100vh",
          backgroundColor: colors.white,
          width: boxWidth,
          overflow: "hidden",
          padding: 0,
          margin: 0,
        }}
      >
        <Loader loading={loading} />
        <Row className="flex-grow-1 m-0 p-0">
          <Col xs="12" md="4">
            <Typography
              variant="h6"
              color="textPrimary"
              sx={{ textAlign: "center" }}
            >
              Your Vehicles
            </Typography>
            <div
              style={{
                boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
                borderRadius: "10px",
              }}
            >
              <VehicleList
                onPressCar={handleTabClick}
              />
            </div>
          </Col>
          <Col xs="12" md="4">
            {Object.keys(getDriverDetails).length > 0 && (
              <BottomVehicleDetails
                locationDetails={getLocationData}
                vehicleDetails={getDriverDetails}
                deviceDetails={deviceDetails}
                vehicleImages={getImagedata}
                onClose={() => { }}
              />
            )}
          </Col>
          <Col xs="12" md="4">
            <Typography
              variant="h6"
              color="textPrimary"
              style={{ textAlign: "center", marginBottom: "5px" }}
            >
              Your Details
            </Typography>
            <ProfileCard
              email={userDetails?.email}
              username={userDetails?.username}
              mobileNumber={userMobileNumber}
              playbackHours={`${convertSecondsToHHMM(
                remainingWatchTime.max_playback_duration
              )} / ${convertSecondsToHHMM(
                remainingWatchTime.playback_remaining_duration
              )}`}
              liveHours={`${convertSecondsToHHMM(
                remainingWatchTime.max_live_duration
              )} / ${convertSecondsToHHMM(
                remainingWatchTime.live_remaining_duration_minutes
              )}`}
              intercomHours={`${convertSecondsToHHMM(
                remainingWatchTime.max_intercomm_duration
              )} / ${convertSecondsToHHMM(
                remainingWatchTime.intercomm_remaining_duration
              )}`}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Profile;
